export class Helper {

    constructor() {}

    static isEmpty(obj): boolean {

        let empty = false;

        if (obj == null) {
            empty = true;
        }

        if (obj === null) {
            empty = true;
        }

        if (typeof obj === 'undefined') {
            empty = true;
        }

        return empty;
    }

}
